import { LOGOUT } from '@plone/volto/constants/ActionTypes';
import { deleteJwtCookie } from 'uniba-volto-jwtsession/helpers/deleteJwtCookie';

const logoutMiddleware = () => (next) => (action) => {
    if (action.type === `${LOGOUT}_SUCCESS` || action.type === `${LOGOUT}_FAIL`) {
        deleteJwtCookie();
    }
    return next(action);
};

export default logoutMiddleware;
